import CustomerEditor from "../../components/Customer/CustomerEditor";

const NewCustomerPage: React.FC = (props) => {
    return <CustomerEditor method="POST" />
}

export default NewCustomerPage;